module.exports = __webpack_public_path__ + "media/images/BG1-c977b1038492b831bfd362ad6c41e477.jpg";